module.exports = __webpack_public_path__ + "static/media/farmer-on-the-frontline-thumbnail_mobile.5180582d.jpg";